import { Agenda } from 'app/model/agenda';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-impostazioni',
	templateUrl: './impostazioni_agenda.html',
	styleUrls: ['./impostazioni_agenda.css']
})

export class SettingsComponent {
	agenda: Agenda;

	constructor(public activeModal: NgbActiveModal) { }

	setAgenda(agenda: Agenda) {
		this.agenda = agenda;
	}
}



// WEBPACK FOOTER //
// ./src/app/impostazioni_agenda/impostazioni_agenda.ts